/**
 * AnimatedSection - GSAP fade-in + stagger voor secties
 */
import { useEffect, useRef, ReactNode } from 'react';
import gsap from 'gsap';

interface AnimatedSectionProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  stagger?: number;
}

export function AnimatedSection({ children, className = '', delay = 0, stagger = 0.1 }: AnimatedSectionProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const animEls = el.querySelectorAll('[data-animate]');
    const hasStagger = animEls.length > 0 && stagger > 0;

    const tl = gsap.timeline({ delay });
    if (hasStagger) {
      tl.fromTo(
        animEls,
        { opacity: 0, y: 16 },
        { opacity: 1, y: 0, duration: 0.5, stagger, ease: 'power2.out' }
      );
    } else {
      tl.fromTo(el, { opacity: 0, y: 16 }, { opacity: 1, y: 0, duration: 0.5, ease: 'power2.out' });
    }

    return () => { tl.kill(); };
  }, [delay, stagger]);

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
}
